import React from 'react';
import {Route} from 'react-router';

import AssignmentsTabContent from './Assignments/Assignments';
import {clearSkillPathCache} from './SkillPath/hooks/useStudentSkillPath';
import {IndependentPractice as IndependentPracticeTabContent} from './IndependentPractice/IndependentPractice';
import sessionStore from 'client/Session/SessionStore';
import {SkillPath as SkillPathTabContent} from './SkillPath/SkillPath';
import StudentHomepage from './StudentHomepage';
import WelcomeComponent from './Welcome';

const BASE_ROUTE = '/home';

export enum Routes {
  Assignments = `${BASE_ROUTE}/assignments`,
  Base = BASE_ROUTE,
  IndependentPractice = `${BASE_ROUTE}/independent-practice`,
  SkillPath = `${BASE_ROUTE}/skill-path`,
  Welcome = `${BASE_ROUTE}/welcome`
}

const StudentHomepageRoutes = (
  <Route
    component={StudentHomepage}
    onEnter={(_nextState, replace, callback) => {
      if (!sessionStore.hasValidSession()) {
        replace('/log-in');
      } else if (!sessionStore.isStudent()) {
        replace('/classes');
      }
      callback?.();
    }}
    onLeave={() => {
      clearSkillPathCache();
    }}
    path='home'
  >
    <Route component={AssignmentsTabContent} path='(class/:classroomId/)assignments' />
    <Route
      component={IndependentPracticeTabContent}
      path='(class/:classroomId/)independent-practice'
    />
    <Route component={SkillPathTabContent} path='(class/:classroomId/)skill-path' />
    <Route component={WelcomeComponent} path='welcome' />
  </Route>
);

export default StudentHomepageRoutes;
